<form [formGroup]="form">
  <div class="apm-card-content d-flex flex-column">
    <div class="row mb-3">
      <div class="col-12">
        <apm-section-title icon="t_assign" title="{{ '444825' | apmTranslate }}"></apm-section-title>
        <apm-select
          [items]="(countries$ | async) || []"
          [multiple]="true"
          [useResourceTemplate]="true"
          formControlName="countries"
          bindValue="id"
          bindLabel="descriptionId"
        >
        </apm-select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <apm-section-title icon="t_assign" title="{{ '444826' | apmTranslate }}"></apm-section-title>
        <apm-select
          [items]="(orgTypes$ | async) || []"
          [multiple]="true"
          [useResourceTemplate]="true"
          formControlName="organizationTypeCodes"
          bindValue="code"
          bindLabel="descriptionId"
        >
        </apm-select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <apm-section-title icon="t_assign" title="{{ '444827' | apmTranslate }}"></apm-section-title>
        <apm-select
          [items]="(organisations$ | async) || []"
          [multiple]="true"
          [virtualScroll]="true"
          formControlName="organizationIds"
          bindValue="id"
          bindLabel="name"
        >
        </apm-select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <apm-section-title icon="t_assign" title="{{ '444828' | apmTranslate }}"></apm-section-title>
        <apm-select
          [items]="(users$ | async) || []"
          [multiple]="true"
          formControlName="specificUsers"
          bindValue="id"
          bindLabel="username"
        ></apm-select>
      </div>
    </div>
  </div>
</form>
